import React, { createContext, useContext, useEffect, useState } from "react";
import { api, tokens } from "../lib/api";

type User = { id: string; email: string; name?: string; role?: string };
type Ctx = { user: User | null | false; login: (e: string, p: string) => Promise<void>; logout: () => Promise<void>; refreshUser: () => void };

const AuthCtx = createContext<Ctx>(null as any);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null | false>(null);

  useEffect(() => {
    if (!tokens.access()) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email: string, password: string) => {
    const { data } = await api.post("/auth/login", { email, password });
    tokens.set(data.access_token, data.refresh_token);
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => null);
    tokens.clear();
    setUser(false);
  };

  const refreshUser = () => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => null);
  };

  return <AuthCtx.Provider value={{ user, login, logout, refreshUser }}>{children}</AuthCtx.Provider>;
}
